import { Guid } from "guid-typescript";
import { IMessage } from "../../IMessage";

//Generated code, do not modify

export class GetBase64FileQuery implements IMessage {
    id!: Guid;

    public constructor(init?: Partial<GetBase64FileQuery>) {
        Object.assign(this, init);
    }

    getMethod = () => "GET";

    getUrl = () => `/admin/images/${this.id.toString()}`;

    getQueryString = () => undefined;

    getBody = () => undefined;
}